import type { PropsWithChildren } from 'react'
import { buildImgSrc, buildImgSrcSet } from '@/helpers/image-url'

import { useEnv } from '@/scopes/common/infrastructure/env'
import { tk, zIndex } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  user-select: none;
  background: ${tk('color_semantic_bg_disabled')};
  display: flex;
  position: relative;
`

const Content = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  user-select: none;
  width: 100%;
  z-index: ${zIndex.heroContent};
`

const BackgroundImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 192px;

  @media ${tk('mq_tablet')} {
    height: 256px;
  }

  @media ${tk('mq_desktop_md')} {
    height: 300px;
  }

  @media (min-width: 460px) {
    object-position: 50% 21%;
  }
`

export function Hero({ children }: PropsWithChildren) {
  const mediaServerBaseUrl = useEnv('MEDIA_SERVER_BASE_URL')
  const imageUrl = `${mediaServerBaseUrl}/bg_qs_sun.jpg`

  return (
    <Wrapper>
      <BackgroundImage
        src={buildImgSrc(imageUrl, 375)}
        srcSet={buildImgSrcSet(imageUrl, [375, 600, 720, 1440, 1440, 2000, 2400])}
        sizes="100vw"
        alt="" // intentionally empty, only for decoration
        // @ts-expect-error -- Not part of the types yet, but this is an img attribute in modern browsers
        fetchpriority="high"
      />
      <Content>{children}</Content>
    </Wrapper>
  )
}
